import { render } from "./UploadSelfieCnh.vue?vue&type=template&id=e770908a"
import script from "./UploadSelfieCnh.vue?vue&type=script&lang=js"
export * from "./UploadSelfieCnh.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__